import * as theme from "../theme";

// Adapted from SimpleQuestion

const BugReportSimpleQuestion = ({
  leftString,
  rightComponent,
  minHeight,
  alignCenter,
  textColor,
  textFamily,
  boldness,
  qTextWidthExlpicit,
  paddingRightExplicit,
  error,
  boxlist,
}) => {
  const qTextWidth = qTextWidthExlpicit ? qTextWidthExlpicit : "50%";
  if (boxlist) alignCenter = "No";
  return (
    <div
      style={{
        width: "100%",
        minHeight: minHeight ? minHeight : theme.SCALES.simpleQuestionsHeight,
        display: "flex",
        alignItems: alignCenter === "No" ? "" : "center",
      }}
    >
      <div
        style={{
          width: qTextWidth,
          height: "100%",
          display: "flex",
          alignItems: "center",
          lineHeight: "2.3vmin",
          letterSpacing: "0.15vmin",
          color: textColor
            ? textColor
            : theme.COLORS.group_tab_header_completed,
          fontFamily: textFamily ? textFamily : "GibsonLight",
          fontWeight: boldness ? boldness : "Bold",
          justifyContent: "flex-end",
          textAlign: "right",
        }}
      >
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
          }}
        >
          <div style={{ width: "92%", height: "100%" }}>{leftString}</div>
          <div
            style={{
              width: "8%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          ></div>
        </div>
      </div>

      <div
        style={{
          width: `calc(100% - ${qTextWidth})`,
          height: "100%",
          paddingRight: paddingRightExplicit ? paddingRightExplicit : "2vw",
        }}
      >
        {rightComponent}
      </div>
      {error ? (
        <div style={{ color: "red", fontSize: "1.5vmin" }}>{error}</div>
      ) : null}
    </div>
  );
};

export default BugReportSimpleQuestion;
